import { useEffect } from "react";
import SockJsClient from "react-stomp";

// const SOCKET_URL = "http://192.168.1.59:8093/ws-message";
const SOCKET_URL = "https://dmswebsocket.byteelephants.com/ws-message";

const WebSocket = ({ topics = "/topic/reminder", setMessage }) => {
    useEffect(() => {
        // Ask for notification permission on mount
        if ("Notification" in window) {
            if (Notification.permission === "default") {
                Notification.requestPermission().then((perm) => {
                    if (perm === "granted") {
                        console.log("✅ Notification permission granted.");
                    } else {
                        console.warn("❌ Notification permission denied.");
                    }
                });
            }
        } else {
            console.warn("⚠️ Browser does not support notifications.");
        }
    }, []);

    const showNotification = (title, options) => {
        if (!("Notification" in window)) return;

        const audio = new Audio("/notification.mp3");
        audio.play().catch(() => { });

        if (Notification.permission === "granted") {
            const notification = new Notification(title, options);

            notification.onclick = () => {
                const userTypeId = localStorage.getItem("userTypeId");
                localStorage.setItem("orderNotificationCount", 0);

                notification.close();

                if (userTypeId == 3) {
                    window.location.replace("/received-order-page");
                } else {
                    window.location.replace("/received-order-list");
                }
            };

        } else if (Notification.permission !== "denied") {
            Notification.requestPermission().then((perm) => {
                if (perm === "granted") new Notification(title, options);
            });
        }
    };

    const handleNotification = (msg) => {
        showNotification("DMS", {
            body: `New Order Arrived`,
            icon: "/icon.png",
        });
    };

    const onConnected = () => console.log("✅ WebSocket connected!");
    const onMessageReceived = (msg) => {
        console.log("📩 Message received:", msg);
        setMessage(msg);
        handleNotification(msg.message);
    };

    return (
        <div>
            <SockJsClient
                url={SOCKET_URL}
                topics={[topics]}
                onConnect={onConnected}
                onDisconnect={() => console.log("❌ WebSocket disconnected!")}
                onMessage={(msg) => onMessageReceived(msg)}
                debug={false}
            />
        </div>
    );
};

export default WebSocket;